import { useState } from 'react';
import WizardCard from '../morning/WizardCard.jsx';

export default function StepWin({ checkout, onUpdate, onBack, onNext }) {
  const [local, setLocal] = useState(checkout?.daily_win || '');

  function handleNext() {
    const trimmed = local.trim();
    onUpdate({ daily_win: trimmed || null });
    onNext();
  }

  return (
    <WizardCard
      step={3}
      totalSteps={4}
      title="One win from today?"
      subtitle="Doesn't have to be big. Just real."
      onBack={onBack}
      onNext={handleNext}
      nextDisabled={!local.trim()}
    >
      <textarea
        value={local}
        onChange={(e) => setLocal(e.target.value)}
        placeholder="What went right…"
        rows={3}
        autoFocus
        className="w-full bg-bg-input border border-border-base rounded px-3 py-2 text-text-primary focus:outline-none focus:border-accent-blue resize-none"
      />
    </WizardCard>
  );
}
